<template>
    <div class="container">
        <div class="container-fluid">
            <div class="text">
                <h1 class="title" v-show="windowWidth >= 700">¿Necesitas algo más?</h1>
                <h1 class="title" v-show="windowWidth < 700">¿Necesitas algo<br> más?</h1>
                <p class="text-body" v-show="windowWidth >= 700">Desde Ademass podemos ayudarte
                    a buscar y formar el perfil que necesitas,<br>
                    a seleccionarlo de manera personalizada y 
                     evaluar sus conocimientos.<br><br>
                    Un experto te escuchará para analizar tus necesidades y facilitarte presupuesto sin<br> 
                    compromiso en caso de necesitar servicios complementarios.
                </p>
                <p class="text-body" v-show="windowWidth < 700">Desde Ademass podemos ayudarte a buscar<br>
                    y formar el perfil que necesitas, a seleccionarlo<br>
                    de manera personalizada y evaluar sus <br>
                    conocimientos.<br><br>
                    Un experto te escuchará para analizar tus necesidades <br> 
                    y facilitarte presupuesto sin compromiso en caso de <br>
                    necesitar servicios complementarios.
                </p>
                <div class="btn-w">
                <a href="mailto:negocio@ademass.com" class="add-talent" target="_blank">
                    Escríbenos
                </a>
            </div>
            </div>
            <div class="img-right" v-if="windowWidth >= 1200">
            <img src="/external/llamanos.png" alt="Rectangle211105" class="frame-rectangle21" />
            </div>
        </div>
    </div>
</template>

<script  setup>
import useWindowWidth from '@/composables/useWindowWidth'

const { windowWidth } = useWindowWidth()
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    width: 80%;
    justify-content: center;
    align-items: center;
    margin-bottom: 100px;
    margin-left: 10%;
    background-color: #2ea3f2;
    border-radius: 15px;
}

@media screen and (max-width: 900px) {
    .container {
        width: 95%;
        height: auto; 
        margin-left: 9px;/* Cambiando a altura automática para que se ajuste al contenido */
    }

    .container-fluid {
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        border-radius: 15px;
        max-width: 100%;
        height: auto; /* Cambiando a altura automática para que se ajuste al contenido */
    }

    .text {
        margin-right: 0;
        margin-left: 20px;
        width: 100%;
    }

    .frame-rectangle21 {
        margin-top: 25px;
        width: 100%; /* Cambiando a 100% para ocupar todo el ancho */
        height: auto;
        border-radius: 25px;
    }

    .title {
        display: flex;
        width: 100%; /* Ajustando a 100% para ocupar todo el ancho */
    }

    .text-body {
        height: auto;
        margin-right: 30px;
        align-items: center;
        flex-direction: column;
        display: flex;
        width: 100%;
    }

    .add-talent {
        width: 100%;
    }

    .text {
        padding: 10px;
        margin-right: 0;
        margin-top: 20px;
        margin-bottom: 50px;
    }

    .frame-rectangle21 {
        margin-top: 25px;
        width: 100%; /* Cambiando a 100% para ocupar todo el ancho */
        height: auto;
        border-radius: 25px;
    }
}

.container-fluid {
    max-width: 100%;
    background-color: #2ea3f2;
    display: flex;
    flex-direction: row;
    padding: 15px;
}

.title {
    margin-bottom: 0;
    color: rgba(255, 255, 255, 1);
    font-size: 40px;
    font-style: Bold;
    text-align: left;
    font-family: Darker Grotesque;
    font-weight: 700;
}

.add-talent {
    padding: 13px;
    border-radius: 25px;
    color: white;
    background-color: rgba(196, 207, 44, 1);
    border: 2px solid rgba(196, 207, 44, 1);
    width: 100%;
    text-decoration: none;
    font-size: 24px;
    font-family: Darker Grotesque;
    display: flex;
    justify-content: center;
    font-weight: 600;
    box-sizing: border-box;
}

.add-talent:hover {
    background-color: white;
    color: rgba(196, 207, 44, 1);
    border: 2px solid rgba(196, 207, 44, 1);
}

.frame-rectangle21 {
    margin-top: 25px;
    margin-left: 30px;
    width: 291px;
    height: 326px;
    border-radius: 25px;
    box-shadow: 50px -20px 0 0 #8F8181;
}

.text {
    display: flex;
    flex-direction: column;
    align-items: center; /* Alineando el contenido al centro */
    justify-content: center;
    margin-right: auto; /* Estableciendo el margen derecho a automático */
    margin-left: auto; /* Estableciendo el margen izquierdo a automático */
    width: 100%;
}

.btn-w {
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
}

.text-body {
    color: white;
    font-size: 24px;
    font-style: Medium;
    font-family: Darker Grotesque;
    font-weight: 500;
    line-height: 94.9999988079071%;
}

</style>
